import React from "react";
import SectionHeader from "./SectionHeader";
import RVEOBeneficiary from "./RVEOBeneficiary";
import { FamilyGroup } from "../../../../interfaces/rveoSimulations";

interface RVEORenderBeneficiariesSectionProps {
  title: string;
  items: FamilyGroup[];
}

const sectionSpacingStyle = { marginTop: "16px" };

const RVEORenderBeneficiariesSection: React.FC<
  RVEORenderBeneficiariesSectionProps
> = ({ title, items }) => {
  if (items.length === 0) return null;

  return (
    <>
      <SectionHeader title={title} style={sectionSpacingStyle} />
      {items.map((beneficiary, index) => (
        <RVEOBeneficiary
          key={`${title}-${index}`}
          beneficiary={beneficiary}
          isLast={index === items.length - 1}
        />
      ))}
    </>
  );
};

export default RVEORenderBeneficiariesSection;